import { render } from "./App.vue?vue&type=template&id=bc71fc52"
const script = {}

import "./App.vue?vue&type=style&index=0&id=bc71fc52&lang=css"
script.render = render

export default script